import { useEffect } from 'react';
import { endpoints } from 'Core/defaultValues';
import { LogManager } from 'Core/logManager';
import { COACH_SSO_LOG_KEY } from '../constants';

const LOG_MESSAGE = `${COACH_SSO_LOG_KEY} postMessage received`;

const getCoachingOrigin = () => {
  try {
    return new URL(endpoints.COACHING_URL).origin;
  } catch {
    return null;
  }
};

// Listens to window "message" events coming from the Coaching iframe.
// Bidirectional messaging is not implemented yet: for now every incoming message is logged
// through LogManager (origin, whether it is the Coaching origin, and the payload) so the
// payloads the Coaching app sends can be inspected. The event object itself is not logged:
// it holds window references that cannot be serialized for DataDog.
export const useCoachingMessages = () => {
  useEffect(() => {
    const coachingOrigin = getCoachingOrigin();

    const handleMessage = (event) => {
      const fromCoaching = Boolean(coachingOrigin && event.origin === coachingOrigin);
      LogManager.info(LOG_MESSAGE, { origin: event.origin, fromCoaching, data: event.data });
    };

    window.addEventListener('message', handleMessage, false);

    return () => {
      window.removeEventListener('message', handleMessage, false);
    };
  }, []);
};
